<template>
  <div class="item item-loading chart" :style="{ width: width + '%', height: height + 'px' }">
    <svg
      v-if="type == 'line'"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="900"
      height="300"
      preserveAspectRatio="none"
      viewBox="0 0 1350 566"
    >
      <defs>
        <clipPath id="a">
          <rect width="1341" height="10" fill="none" />
        </clipPath>
      </defs>
      <g transform="translate(-2268.641 -349)">
        <line
          x2="1342.459"
          transform="translate(2270.5 699.5)"
          fill="none"
          stroke="rgba(153,153,153,0.2)"
          stroke-width="1"
        />
        <line
          x2="1342.459"
          transform="translate(2270.5 609.5)"
          fill="none"
          stroke="rgba(153,153,153,0.2)"
          stroke-width="1"
        />
        <line
          x2="1342.459"
          transform="translate(2270.5 525.5)"
          fill="none"
          stroke="rgba(153,153,153,0.2)"
          stroke-width="1"
        />
        <line
          x2="1342.459"
          transform="translate(2270.5 436.5)"
          fill="none"
          stroke="rgba(153,153,153,0.2)"
          stroke-width="1"
        />
        <line
          x2="1342.459"
          transform="translate(2270.5 349.5)"
          fill="none"
          stroke="rgba(153,153,153,0.2)"
          stroke-width="1"
        />
        <line
          x2="1342.459"
          transform="translate(2270.5 786.5)"
          fill="none"
          stroke="rgba(153,153,153,0.2)"
          stroke-width="1"
        />
        <line
          x2="1342.459"
          transform="translate(2270.5 876.5)"
          fill="none"
          stroke="rgba(153,153,153,0.2)"
          stroke-width="1"
        />
        <path
          d="M511.755,875.885l127.62-85.614,126.263,13.256,95.98-120.455,103.763,14.421,87.348-87.846,142.264,99.619,131.444-161.523,114.251,220.651,114.172-92.788,86.7-11.708,85.923-82.4,83.277,145.326,44.194-43.756"
          transform="translate(1758 -126.791)"
          fill="none"
          stroke="rgba(153,153,153,0.2)"
          stroke-width="4"
        />
        <path
          d="M1854.959,683.072l-44.194,43.756L1727.488,581.5l-85.923,82.4-86.7,11.708-114.172,91.788L1326.438,547.744,1194.994,709.267,1052.73,609.648l-87.348,87.846L861.619,683.072l-95.98,120.455L639.375,790.271l-127.62,85.614v129.888h1343.2Z"
          transform="translate(1758 -126.791)"
          fill="rgba(153,153,153,0.3)"
          opacity="0.1"
        />
        <g transform="translate(2276 905)" clip-path="url(#a)">
          <g transform="translate(-2276 -899)">
            <rect
              width="50"
              height="10"
              rx="5"
              transform="translate(2276 899)"
              fill="rgba(153,153,153,0.1)"
            />
          </g>
          <g transform="translate(-2159 -899)">
            <rect
              width="50"
              height="10"
              rx="5"
              transform="translate(2276 899)"
              fill="rgba(153,153,153,0.1)"
            />
          </g>
          <g transform="translate(-2042 -899)">
            <rect
              width="50"
              height="10"
              rx="5"
              transform="translate(2276 899)"
              fill="rgba(153,153,153,0.1)"
            />
          </g>
          <g transform="translate(-1925 -899)">
            <rect
              width="50"
              height="10"
              rx="5"
              transform="translate(2276 899)"
              fill="rgba(153,153,153,0.1)"
            />
          </g>
          <g transform="translate(-1808 -899)">
            <rect
              width="50"
              height="10"
              rx="5"
              transform="translate(2276 899)"
              fill="rgba(153,153,153,0.1)"
            />
          </g>
          <g transform="translate(-1691 -899)">
            <rect
              width="50"
              height="10"
              rx="5"
              transform="translate(2276 899)"
              fill="rgba(153,153,153,0.1)"
            />
          </g>
          <g transform="translate(-1574 -899)">
            <rect
              width="50"
              height="10"
              rx="5"
              transform="translate(2276 899)"
              fill="rgba(153,153,153,0.1)"
            />
          </g>
          <g transform="translate(-1457 -899)">
            <rect
              width="50"
              height="10"
              rx="5"
              transform="translate(2276 899)"
              fill="rgba(153,153,153,0.1)"
            />
          </g>
          <g transform="translate(-1340 -899)">
            <rect
              width="50"
              height="10"
              rx="5"
              transform="translate(2276 899)"
              fill="rgba(153,153,153,0.1)"
            />
          </g>
          <g transform="translate(-1223 -899)">
            <rect
              width="50"
              height="10"
              rx="5"
              transform="translate(2276 899)"
              fill="rgba(153,153,153,0.1)"
            />
          </g>
          <g transform="translate(-1106 -899)">
            <rect
              width="50"
              height="10"
              rx="5"
              transform="translate(2276 899)"
              fill="rgba(153,153,153,0.1)"
            />
          </g>
          <g transform="translate(-989 -899)">
            <rect
              width="50"
              height="10"
              rx="5"
              transform="translate(2276 899)"
              fill="rgba(153,153,153,0.1)"
            />
          </g>
        </g>
      </g>
    </svg>

    <svg
      v-if="type == 'bar'"
      xmlns="http://www.w3.org/2000/svg"
      width="805"
      height="535.5"
      preserveAspectRatio="none"
      viewBox="0 0 805 535.5"
    >
      <g transform="translate(-199 -370)">
        <rect
          width="70"
          height="10"
          rx="5"
          transform="translate(199 895.5)"
          fill="rgba(153,153,153,0.1)"
        />
        <rect
          width="55"
          height="153"
          rx="4"
          transform="translate(207 714)"
          fill="rgba(153,153,153,0.1)"
        />
        <rect
          width="70"
          height="10"
          rx="5"
          transform="translate(304 895.5)"
          fill="rgba(153,153,153,0.1)"
        />
        <rect
          width="55"
          height="440"
          rx="4"
          transform="translate(312 427)"
          fill="rgba(153,153,153,0.1)"
        />
        <rect
          width="70"
          height="10"
          rx="5"
          transform="translate(409 895.5)"
          fill="rgba(153,153,153,0.1)"
        />
        <rect
          width="55"
          height="301"
          rx="4"
          transform="translate(417 566)"
          fill="rgba(153,153,153,0.1)"
        />
        <rect
          width="70"
          height="10"
          rx="5"
          transform="translate(514 895.5)"
          fill="rgba(153,153,153,0.1)"
        />
        <rect
          width="55"
          height="238"
          rx="4"
          transform="translate(522 629)"
          fill="rgba(153,153,153,0.1)"
        />
        <rect
          width="70"
          height="10"
          rx="5"
          transform="translate(619 895.5)"
          fill="rgba(153,153,153,0.1)"
        />
        <rect
          width="55"
          height="308"
          rx="4"
          transform="translate(627 559)"
          fill="rgba(153,153,153,0.1)"
        />
        <rect
          width="70"
          height="10"
          rx="5"
          transform="translate(724 895.5)"
          fill="rgba(153,153,153,0.1)"
        />
        <rect
          width="55"
          height="497"
          rx="4"
          transform="translate(732 370)"
          fill="rgba(153,153,153,0.1)"
        />
        <rect
          width="70"
          height="10"
          rx="5"
          transform="translate(829 895.5)"
          fill="rgba(153,153,153,0.1)"
        />
        <rect
          width="55"
          height="138"
          rx="4"
          transform="translate(837 729)"
          fill="rgba(153,153,153,0.1)"
        />
        <rect
          width="70"
          height="10"
          rx="5"
          transform="translate(934 895.5)"
          fill="rgba(153,153,153,0.1)"
        />
        <rect
          width="55"
          height="315"
          rx="4"
          transform="translate(942 552)"
          fill="rgba(153,153,153,0.1)"
        />
      </g>
    </svg>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "fakeChart",
  props: {
    type: {
      type: String,
      default: "line"
    },
    width: {
      type: String
    },
    height: {
      type: String
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.item.chart {
  height: 100%;
  box-sizing: border-box;
}
svg {
  width: 100%;
  height: 100%;
  padding: 0 20px;
}
</style>
